<div class="confirm-container">
    <div class="confirmation-content">
        <img class="delete-img" src="/assets/images/delete.png">
        <div *ngIf="title" class="title">
            <span>{{title}}</span>
        </div>
        <div class="description">
            <span>{{message}}</span>
        </div>
    </div>
    <div class="action-block">
        <button class="cancel-button" mat-button (click)="cancel()">{{'cancel' | translate}}</button>
        <button class="confirm-button" mat-button (click)="confirm()">Ok</button>
    </div>
</div>